import React from 'react';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';
import { parseUnixSecondsDate } from 'helpers/time';
export var TimeRange = function TimeRange(_ref) {
  var startTimestamp = _ref.startTimestamp,
      endTimestamp = _ref.endTimestamp;
  var startTime = parseUnixSecondsDate(startTimestamp);
  var endTime = parseUnixSecondsDate(endTimestamp);
  return React.createElement("span", {
    className: "time-range"
  }, React.createElement(FormattedMessage, {
    id: "reservation.date-range",
    defaultMessage: "{startTime, time, short} - {endTime, time, short}",
    values: {
      startTime: startTime,
      endTime: endTime
    }
  }));
};
var TimeStampShape = PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired;
TimeRange.propTypes = {
  startTimestamp: TimeStampShape,
  endTimestamp: TimeStampShape
};